const serviceurl = (state = [], action) => {

  switch (action.type) {
    case 'ADD_SERVICE_URL':
    return action.url.map(url => {
                  return url
                })
    default:
      return state
  }
}

export default serviceurl